import {AfterContentInit, Component, ContentChildren, Input, QueryList, TemplateRef, ViewChild} from '@angular/core';
import {RcTableCellComponent} from './rc-table-cell.component';

@Component({
    selector: 'lib-rc-table-footer-row',
    template: `<ng-template #tableFooterRow>
  <div class="rc-table-footer-row">
    <ng-container *ngFor="let cell of cells.toArray(); let i = index">
        <ng-container [ngTemplateOutlet]="cell.tableCell" [ngTemplateOutletContext]="{col: cols[i]}"></ng-container>
    </ng-container>
  </div>
</ng-template>
`,
    styles: [``]
})
export class RcTableFooterRowComponent implements AfterContentInit{
    @Input() cols: any[] = [];
    @Input() rowData: any[] = [];
    @ContentChildren(RcTableCellComponent) cells: QueryList<RcTableCellComponent>;
    @ViewChild('tableFooterRow', {read: TemplateRef}) tableFooterRow;

    public show;

    ngAfterContentInit() {
    }

}
